import { render, staticRenderFns } from "./ChangePublish.vue?vue&type=template&id=6da90582&"
import script from "./ChangePublish.vue?vue&type=script&lang=js&"
export * from "./ChangePublish.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports